import { render, staticRenderFns } from "./CollectFromInvestors.vue?vue&type=template&id=2d44af98&scoped=true"
import script from "./CollectFromInvestors.vue?vue&type=script&lang=js"
export * from "./CollectFromInvestors.vue?vue&type=script&lang=js"
import style0 from "./CollectFromInvestors.vue?vue&type=style&index=0&id=2d44af98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44af98",
  null
  
)

export default component.exports